import React from 'react';

import WithdrawalMoneyCon from "./../../../Components/Common/WithdrawalMoney";
import Input from "./../Input";

import translate from "./../../../lib/translate/TranslateJs";



function WithdrawalMoney(props) {
    return (
        <WithdrawalMoneyCon
            {...props}
            Input={Input}
            // 充值金额备注信息标签
            MoneyTip={(propCon) => (
                <div className={propCon.type}>{propCon.tip}</div>
            )}
        />
    );
}


export default WithdrawalMoney;

